document.querySelectorAll('.bundle-save__mobile-form').forEach((form) => {
  const variantInput = form.querySelector('[data-bundle-variant-input]');
  const priceLabel = form.querySelector('[data-bundle-price-label]');
  const submitBtn = form.querySelector('[data-bundle-submit]');

  form.querySelectorAll('input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      variantInput.value = radio.value;
      priceLabel.textContent = radio.dataset.bundlePrice || '';
      submitBtn.disabled = !radio.value;
    });
  });
});
